// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanTerminationPropertiesLiteDto
 */
export interface IPlanTerminationPropertiesLiteDto {
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesLiteDto
     */
    claim_last_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPlanTerminationPropertiesLiteDto
     */
    coverage_end_date?: Date;
}

/**
 * Check if a given object implements the IPlanTerminationPropertiesLiteDto interface.
 */
export function instanceOfIPlanTerminationPropertiesLiteDto(value: object): value is IPlanTerminationPropertiesLiteDto {
    return true;
}

export function IPlanTerminationPropertiesLiteDtoFromJSON(json: any): IPlanTerminationPropertiesLiteDto {
    return IPlanTerminationPropertiesLiteDtoFromJSONTyped(json, false);
}

export function IPlanTerminationPropertiesLiteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanTerminationPropertiesLiteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'claim_last_date': json['claim_last_date'] == null ? undefined : (new Date(json['claim_last_date'])),
        'coverage_end_date': json['coverage_end_date'] == null ? undefined : (new Date(json['coverage_end_date'])),
    };
}

export function IPlanTerminationPropertiesLiteDtoToJSON(json: any): IPlanTerminationPropertiesLiteDto {
    return IPlanTerminationPropertiesLiteDtoToJSONTyped(json, false);
}

export function IPlanTerminationPropertiesLiteDtoToJSONTyped(value?: IPlanTerminationPropertiesLiteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'claim_last_date': value['claim_last_date'] == null ? undefined : ((value['claim_last_date']).toISOString().substring(0,10)),
        'coverage_end_date': value['coverage_end_date'] == null ? undefined : ((value['coverage_end_date']).toISOString().substring(0,10)),
    };
}

